/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingSpinnerModule} from '../loading/loading-spinner/loading-spinner.module';
import {FlyingMenuComponent} from './flying-menu.component';

@NgModule({
    declarations: [FlyingMenuComponent],
    exports: [
        FlyingMenuComponent
    ],
    imports: [
        CommonModule,
        LoadingSpinnerModule
    ]
})
export class FlyingMenuModule {
}
